module.exports = __webpack_public_path__ + "static/media/Artboard – 4.a8d65e46.png";